import * as t from 'io-ts';

import type { SelectClearableDefinition } from 'header/types';

import { define, createSpecSettingsInterface } from './_common';
import type { Dimension } from '../../../services';

export interface InternalKeySettingDefinition extends SelectClearableDefinition {
    key: 'INTERNAL_KEY';
    options: Array<{ key: string; label: string } & Dimension>;
}

const definition: InternalKeySettingDefinition = {
    key: 'INTERNAL_KEY',
    type: 'SelectClearable',
    label: 'Internal Key',
    value: '',
    options: [],
    scope: 'designer',
};

const specSettingsInterface = createSpecSettingsInterface(definition, t.union([t.string, t.null]));

export const codec = specSettingsInterface.input;

export const InternalKeySettingDefinition = define({
    key: 'INTERNAL_KEY',
    label: 'internalKey',
    definition,
    fromSetting: settings => specSettingsInterface.extractValue(settings.internalKey),
    createDefinitionWithOpts: (opts = {}) => ({ ...definition, ...opts }),
    createDefinitionFromSpec: settings =>
        specSettingsInterface.createDefinitionWithSettings(settings.internalKey),
});
